import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import { defaultLocale, isSupportedLocale, type Locale } from "@a2/i18n/config";

const CATALOGS: Record<Locale, () => Promise<unknown>> = {
  en: () => import("@a2/i18n/keys/en").then((m) => m.default),
  nl: () => import("@a2/i18n/keys/nl").then((m) => m.default),
  ru: () => import("@a2/i18n/keys/ru").then((m) => m.default),
  tr: () => import("@a2/i18n/keys/tr").then((m) => m.default),
  zh: () => import("@a2/i18n/keys/zh").then((m) => m.default),
  pt: () => import("@a2/i18n/keys/pt").then((m) => m.default),
  fr: () => import("@a2/i18n/keys/fr").then((m) => m.default),
  es: () => import("@a2/i18n/keys/es").then((m) => m.default),
};

let activeLocale: Locale = defaultLocale;
let inited = false;

export async function initI18n(requested: string): Promise<void> {
  const locale = isSupportedLocale(requested) ? requested : defaultLocale;
  const catalog = await CATALOGS[locale]();

  if (!inited) {
    await i18next
      .use(initReactI18next)
      .init({
        lng: locale,
        fallbackLng: defaultLocale,
        resources: { [locale]: { translation: catalog as object } },
        interpolation: { escapeValue: false },
        returnNull: false,
      });
    inited = true;
  } else {
    // Why: addResources flattens nested objects; addResourceBundle preserves JSON structure.
    i18next.addResourceBundle(locale, "translation", catalog as object, true, true);
    await i18next.changeLanguage(locale);
  }

  activeLocale = locale;
  if (typeof document !== "undefined") {
    document.documentElement.setAttribute("lang", locale);
  }
}

export function currentLocale(): Locale {
  return activeLocale;
}
